import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { ArrowRight, UserX } from "lucide-react";

const PASSOS = [
  { para: "aguarda_resposta", de: ["pendente", "em_cotacao"], label: "Cliente informado → Aguarda resposta" },
  { para: "aprovado", de: ["aguarda_resposta"], label: "Cliente aprovou → Aprovar tudo" },
  { para: "faturado", de: ["recebido"], label: "Faturar recebidas" },
  { para: "entregue", de: ["faturado"], label: "Entregar faturadas" },
];
const MOTIVOS = ["Preço", "Prazo de entrega", "Comprou noutro lado", "Já não precisa", "Outro"];
const DESISTIVEIS = ["pendente", "em_cotacao", "aguarda_resposta", "aprovado", "aguarda_fornecedor"];

export const ProximoPasso = ({ pedido, antes, onDone }) => {
  const [dlg, setDlg] = useState(false);
  const [motivo, setMotivo] = useState("");
  const [outro, setOutro] = useState("");
  const ests = (pedido.linhas || []).map((l) => l.estado);
  const passo = PASSOS.find((p) => ests.some((e) => p.de.includes(e)));
  const podeDesistir = ests.some((e) => DESISTIVEIS.includes(e));

  const aplicar = async (para, mot) => {
    await antes();
    try {
      const { data } = await api.post(`/atendimentos/${pedido.id}/estado-pedido`, { para, motivo: mot });
      toast.success(para === "desistencia" ? "Pedido arquivado por desistência." : "Pedido atualizado.");
      onDone(data);
    } catch (err) { toast.error(apiError(err)); }
  };
  const confirmarDesistencia = () => {
    const m = motivo === "Outro" ? outro.trim() : motivo;
    if (!m) { toast.error("Escolha o motivo."); return; }
    setDlg(false); aplicar("desistencia", m);
  };

  return (
    <>
      {passo && (
        <Button size="sm" className="h-8 gap-1 text-xs bg-blue-600 hover:bg-blue-700" onClick={() => aplicar(passo.para)} data-testid={`btn-passo-${passo.para}`}>
          {passo.label} <ArrowRight size={13} />
        </Button>
      )}
      {podeDesistir && (
        <Button size="sm" variant="outline" className="h-8 gap-1 text-xs text-rose-700 border-rose-200 hover:bg-rose-50" onClick={() => { setMotivo(""); setOutro(""); setDlg(true); }} data-testid="btn-desistiu">
          <UserX size={13} /> Cliente desistiu
        </Button>
      )}
      <Dialog open={dlg} onOpenChange={setDlg}>
        <DialogContent data-testid="dlg-desistencia">
          <DialogHeader><DialogTitle>Cliente desistiu — motivo</DialogTitle></DialogHeader>
          <p className="text-xs text-slate-500">As linhas ainda não encomendadas ficam canceladas por desistência e o pedido vai para Arquivados (pode ser reativado).</p>
          <div className="flex flex-wrap gap-1.5">
            {MOTIVOS.map((m) => (
              <button key={m} type="button" onClick={() => setMotivo(m)} data-testid={`motivo-${m}`}
                className={`text-xs border rounded-full px-3 py-1 ${motivo === m ? "bg-rose-50 border-rose-400 text-rose-700" : "border-slate-200 hover:border-slate-400"}`}>{m}</button>
            ))}
          </div>
          {motivo === "Outro" && <Input value={outro} onChange={(e) => setOutro(e.target.value)} placeholder="Escreva o motivo" data-testid="motivo-outro-input" />}
          <DialogFooter><Button className="bg-rose-600 hover:bg-rose-700" onClick={confirmarDesistencia} data-testid="btn-confirmar-desistencia">Arquivar por desistência</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
